
import { Component, Mixins, Watch } from "vue-property-decorator";
import SideMenuLayout from "@/views/sidebar/side-menu-layout.vue";
import EmojiMixin from "@/views/sidebar/emoji-key/emoji-key.mixin";
import { Icon } from "@/views/sidebar/emoji-key/emoji-key.types";

@Component({
  components: {
    "side-menu-layout": SideMenuLayout
  }
})
export default class EmojiComponent extends Mixins(EmojiMixin) {
  loading = false;

  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  }

  async fetchData() {
    const fetch = [
      this.$store.dispatch("EmojiKey/fetchEmojiKeys", this.selectedClientDDL.value)
    ];
    await Promise.all(fetch);
  }

  getName(emojiKey: Icon) {
    return emojiKey.title;
  }
  
  getCss(emojiKey: Icon) {
    return emojiKey.css;
  }

  getStyle(emojiKey: Icon) {
    return {"color" : emojiKey.color};
  }

  @Watch("selectedClientDDL")
  async onClientChange() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  }
}
